import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import {useForm} from 'react-hook-form';
import * as yup from 'yup';

type MatchParams = {};

const formSchema = yup.object().shape({
	domain: yup.string().required('도메인을 입력하세요.'),
	// domain: yup.string().required('도메인을 입력해주세요').url('올바른 url 형식을 입력해주세요'),
});

type FormData = {
	domain: string;
};

function Domain({ match }: RouteComponentProps<MatchParams>) {
	const [loading, setLoading] = useState(false);
	const [doaminName, setDomainName] = useState('');
	const [doaminInfo, setDomainInfo] = useState([] as any[]);
	const [hash, setHash] = useState('');

	const { register, handleSubmit, errors, setValue } = useForm<FormData>({
		validationSchema: formSchema
	});

	useEffect(() => {
		let qsname:string|undefined = window.location.search.split('name=')[1]; 
		if (window.location.search.split('name=')[1] !== undefined) {
			setValue('domain', qsname);
			setDomainName(qsname)
			sendRequest(qsname);
		}
		if (window.location.hash.length !== 0) {
			setHash(window.location.hash);
		}
	}, [match]);

	const onSubmit = (data:FormData) => {
		window.location.search = `?name=${data.domain.replace(/\s/gi, "")}`;
	}

	const sendRequest = (domain:string) => {
		setLoading(true);
		fetch(
			`https://lab.stibee.com/v1/check-domain?name=${domain}`, {
			headers: {
				'X-API-KEY': 'dAnbu3JqHM6MSwzElkfva6ce4DDgKNO45x3DTQ1A',
				// 'Content-Type': 'application/json'
			}
		}).then(res => res.json())
			.then((res) => {
				setLoading(false);
				setDomainName(res.domainName);
				setDomainInfo(res.passStates);
				window.location.hash = hash;
			}).catch((err) => {
				setDomainInfo([]);
				setLoading(false);
			});
			
	}
	
	const valueTitleByType = (type:string, domain:string) => {
		switch(type){
			case 'spf':
				return domain
			case 'dkim':
				return `stb._domainkey.${domain}`
			case 'dmarc':
				return `_dmarc.${domain}`
			default: 
				return '현재 설정 값'
		}
	}

	return (
		<div className="domain" >
			<header className="domain-header">
				<h1>도메인 인증 상태 조회하기</h1>
				<p>발신자 이메일 주소 도메인에 대한 SPF, DKIM, DMARC 설정 상태를 조회합니다.</p>
			</header>
			
			<form className="domain-form" onSubmit={handleSubmit(onSubmit)} >
				<fieldset>
					<input 
						type="text" 
						name="domain" 
					 	id="domain" 
						className={errors.domain && 'error'}
						placeholder="예. stibee.com" 
						ref={register}/>
					<button type="submit">
						조회하기
					</button>	
					{errors.domain && (<div className="msg-err">{errors.domain.message}</div>)}
				</fieldset>
			</form>

			<div className="domain-content">
				{
					doaminInfo.length === 0 ? (
						<></>
					) : (
						<>
						{
							doaminInfo.map((props:any) => (
								<div className={`box ${props.isOk ? 'confirm' : 'warn'}`} key={props.type} id={props.type}>
									<header className={props.isOk ? 'confirm' : 'warn'}>
										<h1>{props.type}</h1>
									</header>
									<div className="text">
										{
											valueTitleByType(props.type, doaminName)
										}
										<br />
										<pre>{props.rawString}</pre>
										{
											props.todoMessage.length !== 0 && (
												<p className="msg" dangerouslySetInnerHTML={{ __html: props.todoMessage }}></p>
											)
										}
									</div>
								</div>
							))
						}							
						</>
					)
				}
				<div className="domain-guide">
					<p>
						SPF, DKIM, DMARC를 설정하면 이메일이 스팸으로 분류되는 것을 방지해 도달률을 높일 수 있습니다.
						자세한 내용은 <a href="https://help.stibee.com/hc/ko/articles/4756529633423-SPF-DKIM이-뭔가요-" target="_blank">SPF, DKIM이 뭔가요?</a>, <a href="https://help.stibee.com/hc/ko/articles/8640149224591-DMARC-%EC%84%A4%EC%A0%95%EC%9D%B4-%EB%AD%94%EA%B0%80%EC%9A%94" target="_blank">DMARC 설정이 뭔가요?</a>를 참고하세요.
					</p>
				</div>
			</div>
		</div>
	)
}

export default Domain;